
import { Options, Vue } from 'vue-class-component';
import { mapMutations, mapState } from 'vuex';
// Types
import { Alternative as AlternativeType } from '@/types/quiz.d';

@Options({
  computed: mapState(['alternativeSelected']),
  props: {
    alternative: {
      type: Object,
    },
  },
  watch: {
    alternativeSelected(value: AlternativeType) {
      if (this.alternative.id === value.id) {
        this.selected = true;
      } else {
        this.selected = false;
      }
    },
  },
  methods: mapMutations(['UPDATE_ALTERNATIVE_SELECTED']),
})
export default class Alternative extends Vue {
  alternative!: AlternativeType;

  alternativeSelected!: AlternativeType;

  selected = false;

  UPDATE_ALTERNATIVE_SELECTED!: (alternative: AlternativeType) => void;

  selectAlternative(): void {
    this.UPDATE_ALTERNATIVE_SELECTED(this.alternative);
  }
}
